import useSWR, { SWRConfiguration } from 'swr';

import { GetAllAsync } from '../../services/api';
import { KendoGridResult } from '../../types/KendoGridResult';
import { OrganisationResponse } from '../../types/responses/organisation-response';

const OrganisationsEndpoint = `organisations`;

export const useGetAllNetworkOrganisations = (
  params?: string,
  options?: SWRConfiguration
) => {
  const { data, error, isLoading, mutate } = useSWR<
    KendoGridResult<OrganisationResponse>
  >(`${OrganisationsEndpoint}/network?${params}`, GetAllAsync, options);

  if (error) console.log(error);

  return {
    data,
    isLoading,
    isError: error,
    mutate
  };
};

export const useGetAllOrganisationsAdmin = (
  params?: string,
  options?: SWRConfiguration
) => {
  const { data, error, isLoading, mutate } = useSWR<
    KendoGridResult<OrganisationResponse>
  >(`${OrganisationsEndpoint}?${params}`, GetAllAsync, options);

  if (error) console.log(error);

  return {
    data,
    isLoading,
    isError: error,
    mutate
  };
};
